import axios from '@/api';

export default {
  async saveSteps({ getters, dispatch }, steps) {
    const id = getters.getId;
    const application = {
      items: [
        {
          steps: steps,
        },
      ],
    };

    if (id) await dispatch('updateApplication', { id, application });
    else await dispatch('createApplication', { application });

    return id;
  },
  async createApplication({ commit, rootGetters }, { application }) {
    const id = await axios
      .post('carrierapplications', application, {
        headers: { recaptcha: rootGetters['getGoogleVerifyKey'] },
      })
      .then(response => response.data)
      .then(response =>
        response.items.length > 0 ? response.items[0].id : null
      );

    commit('setId', id);

    return id;
  },
  async updateApplication(context, { id, application }) {
    await axios.put(`carrierapplications/${id}`, application);
    return id;
  },
  async fetchApplication({ commit }, id) {
    return await axios
      .get(`carrierapplications/${id}`)
      .then(response => response.data)
      .then(response => (response.items.length > 0 ? response.items[0] : null))
      .then(response => {
        if (response) {
          commit('setApplication', response);
        }
        return response;
      });
  },
  async checkEmailIsUse(content, { email }) {
    return await axios
      .post('lookup/carriers/email', {
        items: [
          {
            email: email,
          },
        ],
      })
      .then(response => response.data)
      .then(response => response.items[0].inUse);
  },
};
